import React, { useEffect, useState } from "react";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import Card from "components/SettingsCards/Card";
import { useTranslation } from "../../../contexts/TranslationContext";
import Profile from "assets/icons/Profile.svg";
import MapPoint from "assets/icons/MapPoint.svg";
import MaritialStatus from "assets/icons/MaritialStatus.svg";
import Notes from "assets/icons/Notes.svg";
import Documents from "assets/icons/Documents.svg";
import Terms from "assets/icons/Terms.svg";
import Notifications from "assets/icons/Notifications.svg";
import Installment from "assets/icons/Installment.svg";
import ContactUs from "assets/icons/ContactUs.svg";
import Question from "assets/icons/Question.svg";
import Phone from "assets/icons/Phone.svg";
import Lock from "assets/icons/Lock.svg";
import routes, { appRoute } from "shared/constants/routes";
import { useNavigate } from "react-router-dom";
import { useGetUserAppsQuery } from "services/auth";
import InstallmentSelectModal from "./InstallmentSelectModal";
import NoApplicationModal from "./NoApplicationModal";
import SalaryInfoSvg from "assets/icons/SalaryInfoSvg.svg";

const Setting = () => {
  const { translate } = useTranslation();
  const navigate = useNavigate();
  const { language } = useTranslation();
  const isRtl = language.dir === "rtl"; // Check if the current language direction is RTL

  const user = JSON.parse(localStorage.getItem("@@TAMWEEL_USER") || "null");
  const isV2User = user?.upgrade === true;

  // Only V2 users go through the SIGNED-application gate below; V1 keeps its
  // existing direct navigation (InstlmntDashboard handles V1 multi-app selection itself).
  const { data: apps, isLoading: appsLoading } = useGetUserAppsQuery(
    user?.IDB_USR_ID,
    { skip: !isV2User }
  );

  const [pendingInstallmentCheck, setPendingInstallmentCheck] = useState(false);
  const [selectModalOpen, setSelectModalOpen] = useState(false);
  const [noAppModalOpen, setNoAppModalOpen] = useState(false);
  const [selectedApplId, setSelectedApplId] = useState(null);

  // Eligible = V2 applications whose contract is SIGNED (case-normalized) —
  // same rule as the Other Services Restructure/Topup flow.
  const signedApps = (apps || []).filter(
    (a) =>
      a?.__apiSource === "v2" &&
      String(a?.CONTRACT_STATUS).toUpperCase() === "SIGNED"
  );

  // Waits for the apps fetch to resolve (it may still be loading at click
  // time), then opens the appropriate modal.
  useEffect(() => {
    if (!pendingInstallmentCheck || appsLoading) return;
    setPendingInstallmentCheck(false);
    if (signedApps.length === 0) {
      setNoAppModalOpen(true);
    } else {
      setSelectedApplId(null);
      setSelectModalOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingInstallmentCheck, appsLoading]);

  // Single function to handle all navigations
  const navigateTo = (route) => {
    navigate(appRoute(route));
  };

  const handleInstallmentClick = () => {
    if (!isV2User) {
      navigateTo(routes.SETTING.INSTLMNT_DASHBOADRD);
      return;
    }
    setPendingInstallmentCheck(true);
  };

  const handleContinueSelect = () => {
    if (!selectedApplId) return;
    setSelectModalOpen(false);
    navigate(appRoute(routes.SETTING.INSTLMNT_DASHBOADRD), {
      state: { applId: selectedApplId },
    });
  };

  return (
    <div className="rounded-xl min-h-16 mb-4 px-4 py-8 bg-white items-center shadow-[0_4px_10px_-2px_rgba(0,0,0,0.1),0_-4px_10px_-2px_rgba(0,0,0,0.05)]">
      <div className="gap-3 flex items-center">
        <div
          className="bg-[#F3EDDD] rounded-lg hover:bg-gray-100 transition duration-300 flex items-center justify-center w-10 h-10"
          onClick={() => navigateTo(routes.HOME)}
        >
          {isRtl ? (
            <ArrowRightOutlined className="text-black text-lg font-extrabold" />
          ) : (
            <ArrowLeftOutlined className="text-black text-lg font-extrabold" />
          )}
        </div>
        <div className="text-[#161616] text-[22px] font-normal font-sans">
          {translate("SETTINGS.BACK_TO_HOME")}
        </div>
      </div>
      {/* Responsive grid layout */}
      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-4 gap-x-10 mt-4 w-full px-10">
        {/* <Card
          bgColor="#006E7EB2"
          svg={<img src={Profile} alt="Profile" />}
          title={translate("SETTINGS.PERSONAL_DATA")}
          description={translate("SETTINGS.PERSONAL_DATA_DES")}
          onArrowClick={() => navigateTo(routes.SETTING.PERSONAL_DETAIL)}
        />
        <Card
          bgColor="#FFC243B2"
          svg={<img src={MapPoint} alt="Map" />}
          title={translate("SETTINGS.ADDRESS_DETAILS")}
          description={translate("SETTINGS.ADDRESS_DETAILS_DES")}
          onArrowClick={() => navigateTo(routes.SETTING.ADDRESS_DETAIL)}
        />
        <Card
          bgColor="#BCBDCE"
          svg={<img src={MaritialStatus} alt="Maritial Status" />}
          title={translate("SETTINGS.MARITAL_STATUS")}
          description={translate("SETTINGS.MARITAL_STATUS_DES")}
          onArrowClick={() => navigateTo(routes.SETTING.MARITAL_STATUS)}
        /> */}
        <Card
          bgColor="#A1B8E4"
          svg={<img src={Lock} alt="Reset Password" />}
          title={translate("SETTINGS.CHANGE_PASSWORD")}
          description={translate("SETTINGS.CHANGE_PASSWORD_DES")}
          onArrowClick={() => navigateTo(routes.SETTING.CHANGE_PASSWORD)}
        />
        {/* <Card
          bgColor="#919094"
          svg={<img src={Notes} alt="Notes" />}
          title={translate("SETTINGS.ELIGIBILITY")}
          description={translate("SETTINGS.ELIGIBILITY_DES")}
          onArrowClick={() => navigateTo(routes.SETTING.ELIGIBILITY)}
        /> */}
        {/* <Card
          bgColor="#C1D3FF"
          svg={<img src={Documents} alt="Documents" />}
          title={translate("SETTINGS.DOCUMENT")}
          description={translate("SETTINGS.DOCUMENT_DES")}
          onArrowClick={() => navigateTo(routes.SETTING.DOCUMENT)}
        /> */}
        <Card
          bgColor="#6E1313B5"
          svg={<img src={Question} alt="FAQ" />}
          title={translate("SETTINGS.FAQ")}
          description={translate("SETTINGS.FAQ_DES")}
          onArrowClick={() => navigateTo(routes.SETTING.FAQ)}
        />
        <Card
          bgColor="#50C87854"
          svg={<img src={Phone} alt="Phone" />}
          title={translate("SETTINGS.HELP_AND_SUPPORT")}
          description={translate("SETTINGS.HELP_AND_SUPPORT_DES")}
          onArrowClick={() => navigateTo(routes.SETTING.CONTACT_US)}
        />
        <Card
          bgColor="#FF88004D"
          svg={<img src={Terms} alt="Terms" />}
          title={translate("SETTINGS.TERMS_AND_CONDITION")}
          description={translate("SETTINGS.TERMS_AND_CONDITION_DES")}
          onArrowClick={() => navigateTo(routes.SETTING.TERMS_AND_CONDITION)}
        />
        <Card
          bgColor="#FF88004D"
          svg={<img src={Notifications} alt="Notifications" />}
          title={translate("SETTINGS.MANAGE_OFFERS")}
          description={translate("SETTINGS.MANAGE_OFFERS_DES")}
          onArrowClick={() => navigateTo(routes.SETTING.MANAGE_OFFERS)}
        />
        <Card
          bgColor="#FF88004D"
          svg={<img src={Installment} alt="Installments" />}
          title={translate("SETTINGS.INSTALLMENT_DASHBOARD")}
          description={translate("SETTINGS.INSTALLMENT_DASHBOARD_DES")}
          onArrowClick={handleInstallmentClick}
        />
        <Card
          bgColor="#006E7E"
          svg={<img src={ContactUs} alt="Contact Us" />}
          title={translate("SETTINGS.CONTACT_US")}
          description={translate("SETTINGS.CONTACT_US_DES")}
          onArrowClick={() => navigateTo(routes.SETTING.CONTACT_US)}
        />
        <Card
          bgColor="#4D9AA5"
          svg={<img src={SalaryInfoSvg} alt="Salary Info" />}
          title={translate("SETTINGS.SALARY_INFO")}
          description={translate("SETTINGS.SALARY_INFO_DES")}
          onArrowClick={() => navigateTo(routes.SETTING.SALARY_INFO)}
        />
      </div>

      <InstallmentSelectModal
        open={selectModalOpen}
        apps={signedApps}
        selectedAppId={selectedApplId}
        onSelect={setSelectedApplId}
        onCancel={() => setSelectModalOpen(false)}
        onContinue={handleContinueSelect}
      />
      <NoApplicationModal
        open={noAppModalOpen}
        onClose={() => setNoAppModalOpen(false)}
      />
    </div>
  );
};

export default Setting;
